// NPS Survey Info Class
var SurveyInfoService = /** @class */ (function () {
    function SurveyInfoService() {
        this.cmbFormCompleted = "cmbFormCompleted";
        this.isCmbFormCompleted = 'false';
        this.surveyCompleted = "surveyCompleted";
        this.isSurveyCompleted = 'false';
        this.surveyTimeExpired = "surveyTimeExpired";
        this.surveyTimeExpiredValue = "";
    }
    SurveyInfoService.getInstance = function () {
        if (!SurveyInfoService.instance) {
            SurveyInfoService.instance = new SurveyInfoService();
        }
        return SurveyInfoService.instance;
    };
    // Survey expiry time - minutes
    SurveyInfoService.prototype.setTimeExpiredInMintues = function () {
        // Survey expiry time
        var surveyTimeExpiredExpireMinutes = 1;
        var dtDateExpire = new Date();
        dtDateExpire.setTime(dtDateExpire.getTime() + surveyTimeExpiredExpireMinutes * 60 * 1000);
        this.surveyTimeExpiredValue = dtDateExpire.toUTCString();
        localStorage.setItem(this.surveyTimeExpired, this.surveyTimeExpiredValue);
    };
    // Survey expiry time - days
    SurveyInfoService.prototype.setTimeExpiredInDays = function () {
        // Survey expiry time - days
        var surveyTimeExpiredExpireDays = 31;
        var dtDateExpire = new Date();
        dtDateExpire.setTime(dtDateExpire.getTime() + surveyTimeExpiredExpireDays * 1000 * 60 * 60 * 24);
        this.surveyTimeExpiredValue = dtDateExpire.toUTCString();
        localStorage.setItem(this.surveyTimeExpired, this.surveyTimeExpiredValue);
    };
    // Survey expiry time
    SurveyInfoService.prototype.setTimeExpired = function () {
        if (window.location.href.includes("https://www.standardbank.co.za")) {
            this.setTimeExpiredInDays();
        }
        else {
            this.setTimeExpiredInMintues();
        }
        // Hide survey button if any
        // this.hidePageSurveyButton();
    };
    // get cmb form completed name
    SurveyInfoService.prototype.getCmbFormCompletedName = function () {
        return this.cmbFormCompleted;
    };
    // get cmb form completed value
    SurveyInfoService.prototype.getCmbFormCompletedValue = function () {
        return localStorage.getItem(this.cmbFormCompleted);
    };
    // get survey completed name
    SurveyInfoService.prototype.getSurveyCompleteName = function () {
        return this.surveyCompleted;
    };
    // get survey completed value
    SurveyInfoService.prototype.getSurveyCompleteValue = function () {
        return localStorage.getItem(this.surveyCompleted);
    };
    // get survey time expired  name
    SurveyInfoService.prototype.getSurveyTimeExpiredName = function () {
        return this.surveyTimeExpired;
    };
    // get survey time expired value
    SurveyInfoService.prototype.getSurveyTimeExpireValue = function () {
        return localStorage.getItem(this.surveyTimeExpired);
    };
    // get stored value
    SurveyInfoService.prototype.getStoredValue = function (storedKey) {
        return localStorage.getItem(storedKey);
    };
    // set cmb form complete
    SurveyInfoService.prototype.setCmbFormCompleted = function (isCmbFormCompleted) {
        this.isCmbFormCompleted = isCmbFormCompleted;
        localStorage.setItem(this.cmbFormCompleted, isCmbFormCompleted);
    };
    // set survey complete
    SurveyInfoService.prototype.setSurveyCompleted = function (isSurveyCompleted) {
        this.isSurveyCompleted = isSurveyCompleted;
        localStorage.setItem(this.surveyCompleted, isSurveyCompleted);
    };
    // check if survey popup time has expired and if survey should be displayed or not
    SurveyInfoService.prototype.checkEnableSurvey = function () {
        var surveyTimeExpiredValue = localStorage.getItem(this.surveyTimeExpired);
        // Check / Enable / Reset NPS Survey
        if (window.location.href.includes("surveyReset=true")
            || this.getCmbFormCompletedValue() == null
            || this.getSurveyCompleteValue() == null
            || this.getSurveyTimeExpireValue() == null
            || (this.getSurveyTimeExpireValue() === "" && this.getSurveyCompleteValue() === "true")) {
            this.surveyReset();
        }
        else if (window.location.href.includes("surveyReset2=true")) {
            this.enableSurvey();
        }
        else if (surveyTimeExpiredValue) {
            if (surveyTimeExpiredValue != "" && this.getSurveyCompleteValue() === "true") {
                var currentTime = new Date().getTime();
                var surveyTimeExpiredDateValue = Date.parse(surveyTimeExpiredValue);
                if (currentTime >= surveyTimeExpiredDateValue) {
                    // reset stored values
                    this.surveyReset();
                }
                else {
                    this.hidePageSurveyButton();
                }
            }
        }
    };
    // enable survey
    SurveyInfoService.prototype.enableSurvey = function () {
        localStorage.setItem(this.cmbFormCompleted, "false");
        this.setTimeExpired();
    };
    SurveyInfoService.prototype.showHidePollComponents = function (closeModal) {
        this.npsCustomerSurvey = document.querySelector('#form-container-modal-nps-customer-survey');
        this.pollSurvey = document.querySelector('.poll-survey');
        this.pollSurveyToggle = document.querySelector('.poll-survey-toggle');
        this.pollSurveyHeader = document.querySelector('.poll-survey__messenger--header');
        if (this.npsCustomerSurvey) {
            if (this.pollSurvey && this.pollSurveyToggle && this.pollSurveyHeader) {
                if (closeModal) {
                    this.pollSurvey.classList.remove("nps-customer-survey__poll-survey--inc-z-index");
                    this.pollSurveyToggle.classList.remove("nps-customer-survey__poll-survey-toggle--inc-z-index");
                    this.pollSurveyHeader.classList.remove("nps-customer-survey__poll-survey-header--hidden");
                }
                else {
                    this.pollSurvey.classList.add("nps-customer-survey__poll-survey--inc-z-index");
                    this.pollSurveyToggle.classList.add("nps-customer-survey__poll-survey-toggle--inc-z-index");
                    this.pollSurveyHeader.classList.add("nps-customer-survey__poll-survey-header--hidden");
                }
            }
        }
    };
    // reset stored values
    SurveyInfoService.prototype.surveyReset = function () {
        localStorage.setItem(this.cmbFormCompleted, "false");
        localStorage.setItem(this.surveyCompleted, "false");
        localStorage.setItem(this.surveyTimeExpired, "");
        this.displayPageSurveyButton();
    };
    SurveyInfoService.prototype.displayPageSurveyButton = function () {
        // Display survey button if any
        var surveyToggleButton = document.querySelector(".poll-survey-toggle");
        if (surveyToggleButton) {
            surveyToggleButton.style.display = "block";
        }
    };
    SurveyInfoService.prototype.hidePageSurveyButton = function () {
        // Hide survey button if any
        var surveyToggleButton = document.querySelector(".poll-survey-toggle");
        if (surveyToggleButton) {
            surveyToggleButton.style.display = "none";
        }
    };
    return SurveyInfoService;
}());
export { SurveyInfoService };



//////////////////
// WEBPACK FOOTER
// ./services/survey-info.service.ts
// module id = 67
// module chunks = 0